import styles from "./TodoEditor.module.css";
import { Component } from "react";

export default class TodoEditor extends Component {
  state = {
    textValue: "",
  };

  handleChange = (e) => {
    this.setState({ textValue: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const text = this.state.textValue.trim();
    if (!text) return;

    this.props.onAddTodo(text);
    this.setState({ textValue: "" });
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <input
          className={styles.input}
          name="todo"
          value={this.state.textValue}
          onChange={this.handleChange}
        />
        <button className={styles.button}>Add</button>
      </form>
    );
  }
}
